// extracted by mini-css-extract-plugin
export var productImage = "_mf-0";